/**
 * APIフェッチ
 */

import consoleController from "./logUtil";

class FetchAPI {
  /**
   * APIを実行する
   * @param {string} method HTTPメソッド
   * @param {string} path APIのパス
   * @param {object} queryParams クエリパラメータ
   * @param {string} bodyData リクエストボディデータ
   * @returns {object} レスポンス
   */
  async fetchAPI(method, path, queryParams, bodyData) {
    let url = `${process.env.VUE_APP_FACECARE_API_DOMAIN}${path}`;
    if (queryParams) {
      const queryString = new URLSearchParams(queryParams).toString();
      url = `${process.env.VUE_APP_FACECARE_API_DOMAIN}${path}?${queryString}`;
    }

    const request = {
      method,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Api-Key": process.env.VUE_APP_FACECARE_API_KEY,
      },
    };

    if (bodyData !== null) {
      request.body = JSON.stringify(bodyData);
    }

    consoleController(
      "log",
      `【fetchAPI】request: ${url} request: ${JSON.stringify(request, null, 4)}`
    );

    const fetchResponse = await fetch(url, request);
    return fetchResponse;
  }
}

export default {
  fetch: new FetchAPI(),
};
